/**
 * Format cents to dollar display with K/M suffix
 * Examples: $999, $1.23K, $12.34K, $123.45K, $1.23M
 */
export const formatSalesValue = (cents: number): string => {
  const dollars = cents / 100;

  if (dollars >= 1_000_000) {
    return `$${(dollars / 1_000_000).toFixed(2)}M`;
  }
  if (dollars >= 1_000) {
    return `$${(dollars / 1_000).toFixed(2)}K`;
  }
  return `$${Math.round(dollars).toLocaleString()}`;
};

/**
 * Format booking count with comma separators
 * Example: 99999 -> "99,999"
 */
export const formatBookingCount = (count: number): string => {
  return count.toLocaleString();
};
